<template>
  <div class="w-100">
    <div class="d-flex flex-wrap p-list-representation-wrapper align-items-start">
      <Loader class="w-100" :loading="loading">

        <div  class="w-100 p-list-representation-content row mr-auto ml-auto align-items-start">
          <div class="w-100" >
            <appHeader></appHeader>
          </div>

          <div class=" row p-list-representation-data w-100">
            <contentList
            @submit="submit"
            ></contentList>

          </div>

        </div>
      </Loader>
    </div>

  </div>
</template>

<script>
import contentList from '../components/login/contentList';
import appHeader from '../components/includes/AppHeader';
import settings from '../modules/settings';



export default {
  name: "paySalonOwner",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading   : false,
    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
    if (typeof(settings.get('authorization')) != 'undefined') {
      this.$router.push({name:'listRepresentation'})
    }
  },


  methods: {
    submit(data){
      this.loading = true;

      const token = `eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNmI2OWY0NzU5NmFjYjljZWE3NTc2NDM4YWE2MDkyMWRjZTJiMWMyMWY2NGU3NjBmNzE4NGNmZGMwODZiNWU1ZDM5MTY2M2JiYzk4M2U4OGQiLCJpYXQiOjE1ODE3NjY3MjUsIm5iZiI6MTU4MTc2NjcyNSwiZXhwIjoxNjEzMzg5MTI1LCJzdWIiOiIxIiwic2NvcGVzIjpbInZ1ZV9wdWJsaWNfc2NvcGUiXX0.MhHriuGFCQmy1xz7LbZGcwAkFlgWEFylfBZBoTwVXC_SbNx5eSFuExVYOT6bdAGTChT5g_7_rx2IhEYZENJtJsu_k84UkdVqPOaVo-_IE3x1BkZ9jHvyDD8dF1aDDWUzFWFcH64ddFXwoVYtOnBBtwFj1pOlwfbOaGt2xpKB6Jzy5aFXD2dDb7pF-OoSAb1th7RIgOn30P3GeaZrQo26y96lDWhBjcXJleOCVwuOOCwxKrLJu0NgoEjNPTqqhYfI-CZbGzMw0nybsO1jmVWzh64tP2TfFia77k6cJtVNSRyilqmM0JuqiGtjRgxockQuetI0Feub00pV44n4zApQrllVyS7nvKwXz4eNoz-UcXWkXV74wMNqj4bzA-ETxRDrvgmvGZrWUt1x4sCngB9KYzjZ3VhdTIBJimV6LhbVZhKbV7DIkuPDkuQluyFaED7NzqXmvpCjRCzbFIOwDxWIUhZFEP5_vme2pUj2KN_Es-8qn9EQ5F-oAKmqZlnD6d-6VIMEpLQyE54tyTFMcZTTjeXzoZL0pMsZJxKWzt8mmVz4as-vzWmLvS2yiqsdfsIkAAi2x7cO6T6BIyOzqWNONsAQpBGf1YN-d5wZdXoYP0CznLS8PSYjMDPKpGTYEAMCQMvuYt02N5GdUW098H29g7o5wm7VC7ma0BubXx35AvA
      `;

      settings.set('authorization',`Bearer ${token}`);

      this.$store
      .dispatch('login/setDataLogin', {
        data : {
          ...data,
        }
      })
      .then((res)=>{
        this.loading = false;

        if (typeof(res.is_successful) != 'undefined' ) {

            if (res.is_successful) {
              this.$message.success(res.message);
              settings.set('authorization',`Bearer ${res.data}`);
              this.$router.push({name:'listRepresentation'})
            }
            else {
              let concatMessage = '';
              for (let key in res.message) {
                const contentError = res.message[key];
                concatMessage+=contentError + ',';
              }
              this.$message.error(concatMessage)
            }

        }

      })
    }

  }


}
</script>
